import React from 'react';
import App from '../../../common/components/app';
import CategoriesLink from '../../../common/components/categories-link';
import CategoryDesktopHeader from '../../../common/components/category-desktop-header';
import CategoryMobileHeader from '../../../common/components/category-mobile-header';
import LoginScreen from '../../../common/components/login-screen';
import PopoverRoot from '../../../common/components/popovers/popover-root';
import { useSelector } from '../../../common/components/runtime-context';
import NotFoundPage from '../../../common/containers/not-found-page';
import { getCurrentMatch } from '../../../common/router/router-selectors';
import SearchDesktopHeader from '../../../search/containers/search-header/search-desktop-header';
import SearchMobileHeader from '../../../search/containers/search-header/search-mobile-header';
import SearchResultsPage from '../../../search/containers/search-results-page/search-results-page';
import MessageRoot from '../../components/messages/message-root';
import ModalRoot from '../../components/modals/modal-root';
import {
  ROUTE_404,
  ROUTE_ARCHIVE,
  ROUTE_CATEGORIES,
  ROUTE_CATEGORY,
  ROUTE_HASHTAG,
  ROUTE_HOME,
  ROUTE_LOGIN,
  ROUTE_SEARCH,
  ROUTE_TAGS,
} from '../../constants/routes';

import ArchivePage from '../archive-page';
import CategoryPage from '../category-page';
import FeedPage from '../feed-page';
import HashtagPage from '../hashtag-page';
import TagsPage from '../tags-page';

export type RouteProps = Pick<ReturnType<typeof getCurrentMatch>, 'params'>;

const Router: React.FC = (props) => {
  const match = useSelector(getCurrentMatch);

  if (!match.route || !ROUTE_COMPONENT_MAP[match.route]) {
    throw new Error(`Route "${match.route}" - is not implemented`);
  }

  const Component = ROUTE_COMPONENT_MAP[match.route];

  return <Component params={match.params} {...props} />;
};

const ROUTE_COMPONENT_MAP = {
  [ROUTE_404]: WrapComponent(NotFoundPage),
  [ROUTE_LOGIN]: WrapComponent(LoginScreen),
  [ROUTE_CATEGORIES]: WrapComponent(CategoryPage),
  [ROUTE_CATEGORY]: WrapComponent(CategoryPage),
  [ROUTE_HASHTAG]: WrapComponent(HashtagPage),
  [ROUTE_ARCHIVE]: WrapComponent(ArchivePage),
  [ROUTE_TAGS]: WrapComponent(TagsPage),
  [ROUTE_SEARCH]: (props: RouteProps) => (
    <App
      main={<SearchResultsPage params={props.params} />}
      mobileHeader={<SearchMobileHeader params={props.params} />}
      desktopHeader={<SearchDesktopHeader params={props.params} />}
    />
  ),
  [ROUTE_HOME]: WrapComponent(FeedPage),
};

function WrapComponent(
  Component: React.ComponentType<Pick<RouteProps, 'params'>>,
) {
  return (props: RouteProps) => (
    <App
      main={<Component params={props.params} />}
      modalRoot={<ModalRoot />}
      messageRoot={<MessageRoot />}
      popoverRoot={<PopoverRoot />}
      mobileHeader={<CategoryMobileHeader />}
      mobileMenu={<CategoriesLink />}
      desktopHeader={<CategoryDesktopHeader />}
    />
  );
}

export default Router;
